import { formatPercent, truncateMiddle } from '../lib/format.js';
import { seriesColor } from '../lib/series.js';
import type { DraftRow } from './useWeightDraft.js';

export type SplitBarProps = {
  rows: readonly DraftRow[];
  effectivePct: (key: string) => number;
};

/**
 * The split, rendered proportionally so it is legible before any number is read.
 *
 * Shows the EFFECTIVE split — what traffic will actually do — because that is
 * the question the bar is answering.
 */
export function SplitBar({ rows, effectivePct }: SplitBarProps) {
  const live = rows.filter((row) => row.enabled);

  if (live.length === 0) {
    return (
      <p className="border-l-2 border-l-warn bg-(--color-warn-quiet) px-(--space-3) py-(--space-2) text-[length:var(--text-small)]">
        Every destination is paused. Traffic on this path goes to the fallback.
      </p>
    );
  }

  return (
    <div
      className="flex h-[10px] w-full overflow-hidden rounded-(--radius-sm)"
      role="img"
      aria-label={live
        .map((row) => `${truncateMiddle(row.url, 48)} ${formatPercent(effectivePct(row.key))}`)
        .join(', ')}
    >
      {rows.map((row, index) =>
        row.enabled ? (
          <span
            key={row.key}
            className="h-full transition-[flex-grow] duration-(--duration-normal) ease-(--ease-out-expo)"
            style={{ flexGrow: effectivePct(row.key), background: seriesColor(index) }}
          />
        ) : null,
      )}
    </div>
  );
}
